import moment from "moment";

const SortDate = ( array ) => {
    return array.sort((a, b) => {
        if (moment(a.endDateTime) < moment(b.endDateTime)) {
          return -1;
        }
        if (moment(a.endDateTime) > moment(b.endDateTime)) {
          return 1;
        }
        // a debe ser igual b
        return 0;
      })
}
export const SortDateStart = ( array ) => {
    return array.sort((a, b) => {
        if (moment(a.startDateTime)< moment(b.startDateTime)) {
          return -1;
        }
        if (moment(a.startDateTime)> moment(b.startDateTime)) {
          return 1;
        }
        // a debe ser igual b
        return 0;
      })
}

export default SortDate